import addComma from '../../../Functions/numberFormat';
import { useEffect, useRef, useState } from 'react';
import { Pagination } from '@nextui-org/react';
import useAxios from '../../../hooks/useAxios';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Orders = ({ status = '', setOnOrder }) => {
    const { AxiosPrivate } = useAxios()
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const pagination = useRef()
    const [orders, setOrders] = useState([])
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        const get = async () => {
            await AxiosPrivate.get(`order?status_id=${status}&page=${currentPage}`)
                .then(({ data }) => {
                    setOrders(data.data.data)
                    pagination.current = data ? Math.ceil(data.data.total / data.data.per_page) : 1
                })
                .catch(err => alert(err.response?.data.message))
        }
        get()
    }, [status, currentPage])


    const detailOrder = (order) => {
        setOnOrder(order)
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order', order.id);
        navigate({ search: `?${newParams.toString()}` }, { replace: true });
    }

    return (
        <>
            {!!orders ?
                <div className='mb-3 flex flex-col gap-4' dir="rtl">
                    {!!orders.length > 0 ? <>
                        <ul className='flex items-center px-4 flex-wrap'>
                            <li className='text-sm font-semibold sm:flex-[0_0_80px] flex-1 text-center mx-1.5 text-slate-500'>کد سفارش</li>
                            <li className='text-sm font-semibold sm:flex-[0_0_150px] flex-1 text-center mx-1.5 text-slate-500'>تاریخ</li>
                            <li className='hidden sm:block text-sm font-semibold flex-1 text-center mx-1.5 text-slate-500'>مبلغ نهایی</li>
                            <li className='hidden sm:block text-sm font-semibold flex-[0_0_0] text-center mx-1.5 text-slate-500 px-5'></li>
                        </ul>
                        <ul className='flex flex-col gap-4'>
                            {orders.map(o => {
                                return (
                                    <li key={o.id} className='flex flex-wrap w-full items-center rounded-lg shadow-md py-3.5 sm:px-4 bg-gray-50 cursor-pointer duration-300 hover:shadow-lg  [&>*]:mx-1.5 [&>*]:text-center' onClick={() => detailOrder(o)}>
                                        <p className='sm:flex-[0_0_80px] flex-1 text-xs'>{o.code}</p>
                                        <p className='text-xs sm:flex-[0_0_150px] flex-1'>{new Date(o.created_at).toLocaleDateString('fa-IR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
                                        <p className='hidden sm:block flex-1 text-xs'>{addComma(o.price)} <span className='text-[10px]'>تومان</span></p>
                                        <div className='hidden sm:block !flex-[0_0_0] !m-0 px-4'>
                                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"></path></svg>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </>
                        : <div className='w-full centerOfParent'>
                            <p>سفارشی ندارید</p>
                        </div>}
                    <div dir="auto" className="centerOfParent mt-4">
                        {!!orders.length && pagination.current > 1 &&
                            <Pagination size='sm'
                                total={Math.ceil(pagination.current)}
                                color="primary"
                                page={currentPage}
                                onChange={setCurrentPage}
                                showControls
                            />}
                    </div>
                </div>
                : <div className='w-full centerOfParent'>درحال بارگزاری ...</div>}
        </>
    );
};

export default Orders;